import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";
import moment from "moment";

/**
 *
 * @returns {Promise<void>}
 */
export async function reportGenerate({ state, commit }) {
    commit("setPreloader", true);

    const params = {
        ...state.params,
        branchoffice_id: localStorage.selected_branchoffice
    }

    await $http({
        url: "/api/reportes/sugerido-de-reposicion",
        method: "GET",
        responseType: "blob",
        params
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            const fecha = new Date();
            link.setAttribute(
                "download",
                `Sugerido-Reposición-${moment(fecha).format(
                    "YYYY-MM-DD hh-mm-ss"
                )}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
    commit("setPreloader", false);
}

export async function getSuggestedReplacement({ state, commit }) {
    commit("setPreloader", true);

    const params = {
        noDownload: true,
        branchoffice_id: localStorage.selected_branchoffice
    }

    await $http
        .get(`/api/reportes/sugerido-de-reposicion`, {
            params
        })
        .then(response => {
            commit("setSuggestedReplacement", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    commit("setPreloader", false);
}



// WEBPACK FOOTER //
// ./src/modules/suggested_replacement/actions.js